import React, { useEffect, useState } from "react";
import Button from "../../Button/Button";
import './OneMonth.css';
import { monthArr } from "./Types/CalendarOneMonthType";
import ToolTipComponent from "../../Tooltips/Tooltip";
import { SettingsUserState } from "../../../Types/Types";
import { useSelector } from "react-redux";

interface OneMonthCalendarProps {
    onSelectedChange?: (selectedMonthDays: number[]) => void,
    selectedPayload?: number[]
}

function generateMont(payload?: number[]) {
    const arrMonth: monthArr[] = []
    for (let i = 0; i <= 31; i++) {
        arrMonth.push({day: i, isSelected: false})
    }
    return arrMonth
}

export default function OneMonthCalendar({ onSelectedChange, selectedPayload }: OneMonthCalendarProps) {
    const settingsUser = useSelector((state: SettingsUserState) => state.settings.settings);
    const [arrMonthDays, setArrMonthDays] = useState<monthArr[]>(generateMont(selectedPayload) || []);
    const [isPicked, setIsPicked] = useState<boolean>(selectedPayload?.length === 1 ? selectedPayload[0] === 0 ? true : false : false);
    
    useEffect(() => {
        setIsPicked(arrMonthDays[0].isSelected)
    }, [arrMonthDays])

    const handleOnChangeDay = (monthDay: number) => {
        setArrMonthDays((prevState: monthArr[]) => {
            const newState = prevState.map((el) => 
            el.day === monthDay ? {...el, isSelected: !el.isSelected} : el);
            onSelectedChange && onSelectedChange(newState.filter(el => el.isSelected).map(el => el.day))
            return newState
        })
    }
    console.log(arrMonthDays);
    
    useEffect(() => {
        if (selectedPayload) {
            arrMonthDays.forEach(el1 => {
                if (selectedPayload.some(el2 => el1.day === el2)) {
                    el1.isSelected = true
                }
            })
        }
    }, [selectedPayload]) // eslint-disable-line react-hooks/exhaustive-deps

    const stylesList = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        backgroundColor: '#AC98F6', 
        top: '150%', 
        left: '0%', 
        right: '50%', 
        transform: 'translateX(-50%)'
    }
    const stylesListArrow = {
        top: '-8%', 
        right: '12%'
    } 

    // const handleChangeLastDay = () => {
    //     if (arrMonthDays.length > 0) {
    //         setArrMonthDays((prevState: monthArr[]) => {
    //             const newState = prevState.map((el) => 
    //             el.isSelected === true ? {...el, isSelected: !el.isSelected} : el);
                
    //             return newState
    //         })
    //         onSelectedChange && onSelectedChange([0])
    //         setIsPicked(true)
    //     } 
    //     if (isPicked) {
    //         onSelectedChange && onSelectedChange([])
    //         setIsPicked(false)
    //     }
    // }
    
    return (
        <table className="tableContainer">
            <tbody>
                <tr>
                    {
                        arrMonthDays.map((el, index) => {
                            if ((el.day > 0) && (el.day <= 7)) {
                                return (
                                    <td onClick={() => handleOnChangeDay(el.day)} className={`tableContainer__td ${el.isSelected && `selected`}`} key={index}>
                                        <div>{el.day}</div>
                                    </td>
                                )
                            }
                            return null
                        })
                    }
                </tr>
                <tr>
                    {
                        arrMonthDays.map((el, index) => {
                            if ((el.day >= 8) && (el.day <= 14)) {
                                return (
                                    <td onClick={() => handleOnChangeDay(el.day)} className={`tableContainer__td ${el.isSelected && `selected`}`} key={index}>
                                        <div>{el.day}</div>
                                    </td>
                                )
                            }
                            return null
                        })
                    }
                </tr>
                <tr>
                    {
                        arrMonthDays.map((el, index) => {
                            if ((el.day >= 15) && (el.day <= 21)) {
                                return (
                                    <td onClick={() => handleOnChangeDay(el.day)} className={`tableContainer__td ${el.isSelected && `selected`}`} key={index}>
                                        <div>{el.day}</div>
                                    </td>
                                )
                            }
                            return null
                        })
                    }
                </tr>
                <tr>
                    {
                        arrMonthDays.map((el, index) => {
                            if ((el.day >= 22) && (el.day <= 28)) {
                                return (
                                    <td onClick={() => handleOnChangeDay(el.day)} className={`tableContainer__td ${el.isSelected && `selected`}`} key={index}>
                                        <div>{el.day}</div>
                                    </td>
                                )
                            }
                            return null
                        })
                    }
                </tr>
                <tr>
                    {
                        arrMonthDays.map((el, index) => {
                            if ((el.day >= 29) && (el.day <= 31)) {
                                return (
                                    <td onClick={() => handleOnChangeDay(el.day)} className={`tableContainer__td ${el.isSelected && `selected`}`} key={index}>
                                        <div>{el.day}</div>
                                    </td>
                                )
                            }
                            return null
                        })
                    }
                    <td colSpan={4} className="tableContainer__td-button">
                        <div>
                            <ToolTipComponent tooltipHeader={"Важно"} 
                                tooltipDescription={"Последний день месяца не работает в Google Календаре"} 
                                stylesList={stylesList} 
                                stylesListArrow={stylesListArrow} 
                                active={settingsUser.isGCalendarIntegrated}
                                showCloseBtn={false}>
                                <Button showPicked={isPicked ? 'colored' : 'none'} btnType="default" btnSize="xs" title="последний день месяца" onClickFunc={() => handleOnChangeDay(0)} />
                            </ToolTipComponent>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    )
}